import { useEffect } from "react";
import OrganisationProfileCover from "../../../../components/OrganisationAdminProfile/OrganisationProfileCover/component";
import OrganisationProfileView from "../../../../components/OrganisationAdminProfile/OrganisationProfileView/component";
import EmployeeList from "../../../Admin/UserManagement/EmployeeList/component";
import organizationProfileTabStyles from "./OrganizationProfileTab.module.scss";

class OrganizationProfileTabProps {
  organisationProfile;
}

/**
 *
 * @param {OrganizationProfileTabProps} props
 * @returns
 */
export default function OrganizationProfileTab(props) {
  return (
    <div
      className={
        organizationProfileTabStyles.container + " OrganizationProfileTab"
      }
    >
      <OrganisationProfileCover
        profileImage={props.organisationProfile.organizationProfile?.logo ?? ""}
      />
      <OrganisationProfileView
        organisationProfileData={props.organisationProfile.organizationProfile}
        showCancelSubscription={false}
      />
      <EmployeeList
        asPage={false}
        orgId={props.organisationProfile.organizationProfile?.id ?? 0}
      />
    </div>
  );
}
